
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"totalDistanceParticipantStat"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"page"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_operators"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OperatorsFilterFindManyRunStatInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"raceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"MongoID"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalDistanceParticipantStat"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"raceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"raceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"_operators"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_operators"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"perPage"},"value":{"kind":"Variable","name":{"kind":"Name","value":"perPage"}}},{"kind":"Argument","name":{"kind":"Name","value":"page"},"value":{"kind":"Variable","name":{"kind":"Name","value":"page"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genderRank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ageRangeRank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"genderAgeRangeRank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regTypeTabRank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regTypeTabGenderRank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regTypeTabAgeRangeRank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"regTypeTabGenderAgeRangeRank"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"participantId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bibNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"raceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"eventId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gender"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distanceUnit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalDistance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrlProfile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"raceDistance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"teamDistance"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticketCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"runnerCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allRunnerCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"totalRunningScore"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":871}};
    doc.loc.source = {"body":"query totalDistanceParticipantStat ($eventId:MongoID, $perPage: Int $page: Int, $_operators: OperatorsFilterFindManyRunStatInput, $raceId:MongoID){\n  totalDistanceParticipantStat(filter: {raceId: $raceId, eventId: $eventId, _operators: $_operators}, perPage: $perPage, page: $page) {\n    count\n    items {\n      _id\n      rank\n      genderRank\n      ageRangeRank\n      genderAgeRangeRank\n      regTypeTabRank\n      regTypeTabGenderRank\n      regTypeTabAgeRangeRank\n      regTypeTabGenderAgeRangeRank\n      participantId\n      bibNumber\n      firstName\n      lastName\n      raceId\n      eventId\n      gender\n      distanceUnit\n      distance\n      date\n      totalDistance\n      imageUrl\n      imageUrlProfile\n      raceDistance\n      teamDistance\n      ticketCount\n      runnerCount\n      allRunnerCount\n      createdAt\n      updatedAt\n      totalRunningScore\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["totalDistanceParticipantStat"] = oneQuery(doc, "totalDistanceParticipantStat");
        
